import React, {useEffect} from 'react';
import { Field } from 'formik';
import { RedesignedFileUpload } from '../../../../components';
import { ReactComponent as MoveIcon } from '../../../../assets/icons/MoveIcon.svg';
import { Checkbox, FormControlLabel } from '@mui/material';
import { FileUploadBtn } from '../../../../components/ui-control/fileUploadBtn';
import { Popover } from 'bootstrap';
import { getDefendantId, getDefendantName } from '../../../../utils/helper';

const CaseReportFilesForm = ({ onFileSelected, fileNames, fieldName, documentName, reportName, removeFile, uploadButtonText,defendants=null,updateFileData, isRenderLiabilityFiles }) => {
    useEffect(() => {
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
        popoverTriggerList.forEach((el) => new Popover(el));
    }, []);
    const convertedFilesArray = Array.from(fileNames);
    return (
        <div className="report-section upload-section p-0" >
            <div className="report-btn file-input mb-0">
                <span>{reportName} {isRenderLiabilityFiles && <i
                    className="fa fa-info-circle help-icon"
                    tabIndex="0"
                    role="button"
                    data-bs-toggle="popover"
                    data-bs-trigger="hover"
                    data-bs-content="Select which Defendants apply for each uploaded file">
                </i>}</span>
                <div className="text-end">
                    <FileUploadBtn text={uploadButtonText}/>
                </div>
                <Field name={fieldName} component={RedesignedFileUpload} multiplefileUpload={true} onFileSelected={onFileSelected} documentName={documentName} accept="application/pdf" />
            </div>
            {convertedFilesArray.length > 0 && convertedFilesArray?.map((file, i) => (
                <div key={i} className="report-item">
                    <div className="d-flex align-items-center gap-2 text-nowrap">
                        <div className='flex-grow-1'>
                            <MoveIcon />
                        </div>
                        {(defendants  && !file.s3UrlPath) ? file.file?.name : file?.name}
                        {defendants && 
                        <div className="ms-3 ps-3  d-flex align-items-center gap-2 def_checkbox_wrap">
                            {defendants?.map((defendant,index)=>{
                                return <FormControlLabel control={<Checkbox checked={file.defendants.includes(getDefendantId(defendant))} onChange={(e)=>{updateFileData(file.s3UrlPath?file._id:file?.id,getDefendantId(defendant),e.target.checked)}}/>} key={getDefendantId(defendant)+index} className='def_checkbox' label={getDefendantName(defendant)}/>
                            })}
                        </div>}
                    </div>
                    <button type='button' className="delete-btn" onClick={() => removeFile(file)}>
                        <i className="fas fa-trash-alt"></i>
                    </button>
                </div>
            ))}
        </div >
    )
}

export default CaseReportFilesForm;